import { ChevronRight } from '@maistodos/core-icons'
import { Typography, useTheme } from '@maistodos/design-system-web'

import { RecommendedBadge } from '@/modules/checkout/components/FormPix/RecommendedBadge'

import { PixOptionCardProps } from './types'

export const PixOptionCard = ({
  icon,
  title,
  description,
  recommended,
  onClick,
}: PixOptionCardProps) => {
  const theme = useTheme()

  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-full cursor-pointer items-center gap-spacing8 rounded-small border border-neutral200 bg-neutral0 p-spacing12 text-left transition-colors hover:border-brand500"
    >
      <span
        aria-hidden
        className="flex h-spacing32 w-spacing32 shrink-0 items-center justify-center"
      >
        {icon}
      </span>

      <span className="flex flex-1 flex-col items-start gap-spacing8">
        {recommended ? <RecommendedBadge /> : null}

        <Typography as="span" variant="small" color="neutral900">
          <strong className="text-brand500">{title}:</strong> {description}
        </Typography>
      </span>

      <span aria-hidden>
        <ChevronRight color={theme.colors.neutral400} fontSize="24px" />
      </span>
    </button>
  )
}
